export default __webpack_public_path__ + "static/1aa-110122daab70e1e6884cb20d735f71ca.png";